import { Link } from 'react-router-dom';
import { ArrowLeft, HelpCircle, MessageCircle, Search, FileQuestion } from 'lucide-react';

export function HelpPage() {
  return (
    <div className="bg-slate-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-slate-500 hover:text-blue-600 mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver al inicio
        </Link>

        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Centro de Ayuda</h1>
          <p className="text-lg text-slate-600">¿En qué podemos ayudarte hoy?</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-4">
              <Search className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">Cómo buscar</h3>
            <p className="text-slate-600 mb-4">
              Aprende a utilizar los filtros para encontrar el trastero perfecto cerca de ti.
            </p>
            <Link to="/search" className="text-blue-600 font-medium hover:underline">Ir al buscador &rarr;</Link>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center text-green-600 mb-4">
              <MessageCircle className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">Cómo publicar</h3>
            <p className="text-slate-600 mb-4">
              Guía paso a paso para subir tu anuncio gratis y conseguir interesados rápido.
            </p>
            <Link to="/publish" className="text-blue-600 font-medium hover:underline">Publicar ahora &rarr;</Link>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="p-6 border-b border-slate-100">
            <h2 className="text-xl font-bold text-slate-900 flex items-center gap-2">
              <FileQuestion className="w-5 h-5 text-slate-400" />
              Preguntas Frecuentes
            </h2>
          </div>
          <div className="divide-y divide-slate-100">
            <FaqItem 
              question="¿Es realmente gratis publicar?" 
              answer="Sí, publicar anuncios en EncuentraTrastero es 100% gratuito para particulares y profesionales." 
            />
            <FaqItem 
              question="¿Cómo contacto con un propietario?" 
              answer="En la página de detalle de cada anuncio verás los botones para llamar o enviar un mensaje directamente al propietario." 
            />
            <FaqItem 
              question="¿Qué hago si veo un anuncio sospechoso?" 
              answer="Por favor, contáctanos inmediatamente a info@encuentratrastero.com indicando el enlace del anuncio para que lo revisemos." 
            />
            <FaqItem 
              question="¿Cómo edito mi anuncio?" 
              answer="Entra en tu Perfil, busca el anuncio y verás las opciones para editar o eliminar." 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function FaqItem({ question, answer }: { question: string, answer: string }) {
  return (
    <div className="p-6 hover:bg-slate-50 transition-colors">
      <h3 className="font-semibold text-slate-900 mb-2">{question}</h3>
      <p className="text-slate-600 text-sm">{answer}</p>
    </div>
  );
}
